// extracted by css-extract-rspack-plugin
export default {"container":"src-app-components-forms-TextBox-TextBox-module__container-DGK81o","noPadding":"src-app-components-forms-TextBox-TextBox-module__noPadding-JoTGOV","transparent":"src-app-components-forms-TextBox-TextBox-module__transparent-JK3mXa","readonly":"src-app-components-forms-TextBox-TextBox-module__readonly-tayj19"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"container\":\"src-app-components-forms-TextBox-TextBox-module__container-DGK81o\",\"noPadding\":\"src-app-components-forms-TextBox-TextBox-module__noPadding-JoTGOV\",\"transparent\":\"src-app-components-forms-TextBox-TextBox-module__transparent-JK3mXa\",\"readonly\":\"src-app-components-forms-TextBox-TextBox-module__readonly-tayj19\"}";
        // 1789362522834
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  